export enum OpacityToken {
  opacityLevelSemiopaque = '0.72',
  opacityLevelIntense = '0.64',
  opacityLevelMedium = '0.32',
  opacityLevelLight = '0.16',
  opacityLevelSemitransparent = '0.08',
}

export default OpacityToken

export type TOpacity =
  | 'opacityLevelSemiopaque'
  | 'opacityLevelIntense'
  | 'opacityLevelMedium'
  | 'opacityLevelLight'
  | 'opacityLevelSemitransparent'
